import { render, staticRenderFns } from "./CabinDialog.vue?vue&type=template&id=19c08596&scoped=true&"
import script from "./CabinDialog.vue?vue&type=script&lang=js&"
export * from "./CabinDialog.vue?vue&type=script&lang=js&"
import style0 from "./CabinDialog.vue?vue&type=style&index=0&id=19c08596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c08596",
  null
  
)

export default component.exports